<template>
  <div class="row">
    <div class="col-3 course_score" style="margin-bottom: 16px; text-align: center;">
      <span class="progress_block float-left ml-3" style="height: 32px; width: 70px;">
        <span class="state" :class="statusClass(competencySummary.performance)" style="height: 32px; width: 70px;">
          <span v-if="isScoreNotAvailable" class="progress_val ace_sec_txt" style="font-size: 15px;">N/A</span>
          <span v-else class="progress_val ace_sec_txt" style="font-size: 15px;">
          {{competencySummary.performance}}%
          </span>
        </span>
      </span>
      <span class="ic_container">
        <button
          class="btn ic_btn ace_sec_txt"
          @click="openOverride"
          :title="$t('modifiedScoreInfoTitle')"
          v-b-tooltip.hover>
            <span class="ic icon-edit"></span>
        </button>
      </span>
      <span class="score_lebel">score</span>
    </div>

    <div class="col-4 competency_summary" v-if="competencySummary">
      <div v-if="competencySummary.lastActivityTime">
        <small>Last Activity: {{millisToDate(competencySummary.lastActivityTime)}}</small>
      </div>
      <div v-if="competencySummary.assessmentTimeTaken">
        <small>Time Spent: {{millisToTime(competencySummary.assessmentTimeTaken)}}</small>
      </div>
    </div>
    <div class="col-5">
      <div class="progress-row" :title="showProgressTitle(competencySummary.childrenCompleteCount, competencySummary.childrenCount)" v-b-tooltip.hover>
        <div class="progress-bar-label">
          {{competencySummary.childrenCompleteCount}} of {{competencySummary.childrenCount}}
        </div>
        <b-progress :max="competencySummary.childrenCount" height="32px">
          <b-progress-bar :value="competencySummary.childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
        </b-progress>
      </div>
    </div>
  </div>
</template>

<script>
  import { DateTime } from 'luxon'
  import { mapActions } from 'vuex'

  export default {
    name: 'advisee-program-course-score-and-progress',
    props: ['courseId', 'userId', 'pObject', 'course'],
    data: () => {
      return {
        mcSummary: {},
        competencySummary: {},
        isScoreNotAvailable: true
      }
    },
    mounted () {
      this.loadCourseProgress()
    },
    methods: {
      ...mapActions([
        'loadMicroCompetencyProgressForSelectedUser',
        'loadCompetencyProgressForSelectedUser'
      ]),
      async loadCourseProgress () {
        this.mcSummary = await this.loadMicroCompetencyProgressForSelectedUser({entityId: this.courseId, userId: this.userId})
        this.competencySummary = await this.loadCompetencyProgressForSelectedUser({entityId: this.courseId, userId: this.userId})
        if (!this.competencySummary.performance) {
          this.competencySummary.performance = 0
        }else{
            this.competencySummary.performance = this.competencySummary.performance.toFixed(2)
        }
        let status = this.competencySummary.status
        if ((status === 1) || (status === 2)) {
          this.isScoreNotAvailable = false
        }
        let data = {
          status: status,
          performance: this.competencySummary.performance
        }
        this.$emit('progressSummary', data)
      },
      openOverride(){
          this.pObject.openOverrideDetailModal(this.course, this.competencySummary)
      },
      statusClass (performance) {
        if (performance && !this.isScoreNotAvailable) {
          if (performance >= 90) {
            return 'gradeA'
          } else if (performance >= 80 && performance < 90) {
            return 'gradeB'
          } else if (performance >= 65 && performance < 80) {
            return 'gradeC'
          } else if (performance >= 40 && performance < 65) {
            return 'gradeD'
          } else if (performance < 40) {
            return 'gradeE'
          }
        } else {
          return 'noGrade'
        }
      },
      showProgressTitle (completedCount, totalCount) {
        if (completedCount == 0) {
          return 'No competency is completed'
        } else if (completedCount > 1) {
          return completedCount + ' of ' + totalCount + ' competencies are completed'
        } else {
          return completedCount + ' of ' + totalCount + ' competency is completed'
        }
      },
      millisToDate (millis) {
        return DateTime.fromMillis(millis).toFormat('MM/dd/yyyy')
      },
      millisToTime (timeTaken) {
        if (timeTaken < 1) {
          return 'N/A'
        }

        let ms = timeTaken % 1000
        timeTaken = (timeTaken - ms) / 1000
        let secs = timeTaken % 60
        timeTaken = (timeTaken - secs) / 60
        let mins = timeTaken % 60
        let hrs = (timeTaken - mins) / 60
        if (hrs < 10) {
          hrs = '0' + hrs
        }
        if (mins < 10) {
          mins = '0' + mins
        }
        if (secs < 10) {
          secs = '0' + secs
        }
        return hrs + ':' + mins + ':' + secs
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/adviseeTracker/components/AdviseeProgramCourseScoreAndProgress.vue